import React from 'react'
import {
  IconChevronsLeft,
  IconChevronLeft,
  IconChevronsRight,
  IconChevronRight,
} from '@tabler/icons-react'

import { Button } from '@/components/buttons/Button'

export const WidgetPagination = ({ olderCursor = null, newerCursor = null, queryDataByCursor }) => {
  return (
    <div
      className="advanced-table__pagination widget-pagination transparent"
      data-testid="widget-pagination"
    >
      <div className="advanced-table__pagination--details" />
      <div className="advanced-table__pagination--arrows">
        <Button
          square
          small
          data-testid="pagination-first"
          disabled={!newerCursor}
          onClick={() => queryDataByCursor('', 0)}
        >
          <IconChevronsLeft />
        </Button>
        <Button
          square
          small
          disabled={!newerCursor}
          data-testid="pagination-prev"
          onClick={() => queryDataByCursor(newerCursor, 0)}
        >
          <IconChevronLeft />
        </Button>
        <Button
          small
          square
          data-testid="pagination-next"
          disabled={!olderCursor}
          onClick={() => queryDataByCursor(olderCursor, 0)}
        >
          <IconChevronRight />
        </Button>
        <Button
          small
          square
          data-testid="pagination-last"
          disabled={!olderCursor}
          onClick={() => queryDataByCursor('', 1)}
        >
          <IconChevronsRight />
        </Button>
      </div>
    </div>
  )
}
